import React from 'react';
import {pathBuilder} from "routes/urlLocations";
import StatusTag from "components/StatusTag/StatusTag";
import UserIcon from '../../assets/img/emptyavatar.png';
import cardBG from 'assets/img/cardBG.png';
import { Link } from 'react-router-dom';

const MarriageNOCCardSkeleton = () => {
    return (
        <div 
            className="w-48 flex flex-col p-4 shadow-sm rounded-lg bg-no-repeat bg-top animate-pulse"
            style={{ backgroundImage: `url(${cardBG})` }}
        >
            <div className="w-20 h-20 rounded-lg bg-gray-200 mx-auto mb-4" />
            <div className="h-5 bg-gray-200 rounded w-3/4 mx-auto mb-2" />
            <div className="h-4 bg-gray-200 rounded w-1/2 mx-auto mb-2" />
            <div className="text-center translate-y-7">
                <div className="h-6 bg-gray-200 rounded w-20 mx-auto" />
            </div>
        </div>
    );
};

const MarriageNOCCard = ({uuid, fullName, photo, status, church}) => {
    return (
        <Link 
            to={pathBuilder.marriageNOCDetails(uuid)}
            className="w-45 sm:w-48 flex flex-col pt-4 px-4 shadow-md rounded-lg bg-no-repeat bg-top transition-shadow duration-300 hover:shadow-lg"
            style={{ backgroundImage: `url(${cardBG})` }}
        >
            <div className="w-20 h-20 rounded-lg border border-gray-500 mx-auto mb-4 overflow-hidden">
                <img 
                    src={photo?.url || UserIcon} 
                    alt=""
                    className="w-full h-full object-cover"
                />
            </div>
            <div className="text-center text-base font-bold text-[#27282B] flex-1">
                {fullName || "NA"}
            </div>
            <div className="text-center text-sm font-normal text-gray-400 flex-1">
                {church?.name}
            </div>
            <div className="text-center translate-y-2.5">
                <StatusTag status={status}/>
            </div>
        </Link>
    );
};

export { MarriageNOCCard, MarriageNOCCardSkeleton };
